'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isUnsafeProperty = require('../_internal/isUnsafeProperty.js');
var isPlainObject = require('../predicate/isPlainObject.js');
function mergeWith(target, source, merge) {
    var sourceKeys = Object.keys(source);
    for(var i = 0; i < sourceKeys.length; i++){
        var key = sourceKeys[i];
        if (isUnsafeProperty.isUnsafeProperty(key)) {
            continue;
        }
        var sourceValue = source[key];
        var targetValue = target[key];
        var merged = merge(targetValue, sourceValue, key, target, source);
        if (merged !== undefined) {
            target[key] = merged;
        } else if (Array.isArray(sourceValue)) {
            if (Array.isArray(targetValue)) {
                target[key] = mergeWith(targetValue !== null && targetValue !== void 0 ? targetValue : [], sourceValue, merge);
            } else {
                target[key] = mergeWith([], sourceValue, merge);
            }
        } else if (isPlainObject.isPlainObject(sourceValue)) {
            if (isPlainObject.isPlainObject(targetValue)) {
                target[key] = mergeWith(targetValue, sourceValue, merge);
            } else {
                target[key] = mergeWith({}, sourceValue, merge);
            }
        } else if (targetValue === undefined || sourceValue !== undefined) {
            target[key] = sourceValue;
        }
    }
    return target;
}
exports.mergeWith = mergeWith;
